import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { camera } from '../../../../../../../../../../shared/assets/emojis';

import ProgressBar from './ProgressBar';

import { Emoji } from 'hosman-material';

import { resetPhotoMeetingSlice } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';
import { getSale } from '../../../../../../../../../reducers/SellerApp/salesSlice';

const SuccessAnimation = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const dispatch = useDispatch();
  const timeOutAfterSuccess = 5000
  const hasExecuted = useRef(false);

  useEffect(() => {
    if (hasExecuted.current) return;
    
    hasExecuted.current = true;
    
    setTimeout(() => {
      dispatch(resetPhotoMeetingSlice());
      dispatch(getSale(sale.id));
    }, timeOutAfterSuccess);
  }, []);

  return (
    <div className='flex flex-col items-center gap-3 text-center'>
      <Emoji emojiSrc={camera} width='w-10' />
      <p className='h1 text-ih-blue'>Prestation confirmée !</p>
      <p className='text-ih-indigo'>Votre prestataire interviendra à l'adresse indiquée, à la date et l'heure que vous avez choisies.</p>
      <ProgressBar timeOutAfterSuccess={timeOutAfterSuccess} />
    </div>  
  )
}

export default SuccessAnimation;
